/**
 * @description 奖励解锁奖励
 */

import { RewardTypeEnum, RewardStatusEnum } from "@/types/reward";
import Image from "next/image";
import { RewardIcon } from "./reward-icon";
import { isEmpty } from "lodash-es";
import ProgressBar from "@/features/reward/components/progress-bar";
import GiftIcon from '@/features/reward/assets/gift-unlock.png';
import { Button } from "@/components/ui/button";
import { useBalanceFormatter } from "@/hooks/use-balance-formatter";
import { useTranslations } from "next-intl";
import { useClaimDebounce } from "./use-claim-debounce";

interface UnlockedRewardProps {
  status: RewardStatusEnum;
  wageredProgress?: {
    currentAmount: number;
    targetAmount: number;
  };
  amount: number;
  currency: string;
  claimCurrency: string;
  claimAmount: number;
  bonusWagerMultiple?: number;
  calendarAmount?: number;
  claimableAmount?: number;
  maxClaimAmount?: number;
  rewardAmount?: number;
  onClaim: () => Promise<unknown>;
}

export const UnlockedReward = (props: UnlockedRewardProps) => {
  const { status, wageredProgress, currency, claimableAmount, maxClaimAmount, onClaim } = props;
  const { formatCurrencyDetail } = useBalanceFormatter();
  const showProgress = status === RewardStatusEnum.PROGRESS;
  const ableClaim = status === RewardStatusEnum.CLAIM;
  const progressPercent = showProgress && !isEmpty(wageredProgress) ?
    (wageredProgress.currentAmount / wageredProgress.targetAmount) * 100 : 0;
  const t_reward = useTranslations('reward');
  const t_referral = useTranslations('referral');
  const { loading, run } = useClaimDebounce(onClaim);
  const handleClaim = async () => {
    return run();
  };

  return (
    <div className="bg-dark-special rounded-lg py-3 pr-3 flex items-center justify-between" style={{ background: 'linear-gradient(to bottom right, #1D3657 0%, #1B2131 65%, #1B2131 100%)', }}>
      <RewardIcon type={RewardTypeEnum.REWARD_UNLOCK} className="mr-2.5" />
      <div className="flex-1">
        <div className="text-white text-xs font-medium leading-3">{t_reward('canWithdrawBonus')}</div>
        {
          showProgress && (
            <>
              <div className="flex items-center justify-between mt-3">
                <div className="text-tertiary text-[11px] font-medium leading-3">
                  {t_reward('wager')} {`${formatCurrencyDetail((wageredProgress?.currentAmount || 0))} / ${formatCurrencyDetail((wageredProgress?.targetAmount || 0)) + ' ' + currency}`}
                </div>
                <Image src={GiftIcon.src} alt="gift" width={12} height={12} />
              </div>
              <ProgressBar progress={progressPercent} className="mt-2 h-2" barClassName="bg-accent-blue" />
            </>
          )
        }
        {
          (ableClaim && (!!claimableAmount || !!maxClaimAmount)) && (
            <div className="flex items-center mt-2 leading-3">
              <div className="text-[#FFC600] text-xss font-medium">
                {!maxClaimAmount && !!claimableAmount && `${formatCurrencyDetail(claimableAmount)} ${currency} ${t_referral('claimableCommission')}`}
                {!!maxClaimAmount && `${t_reward('maxUpTo', { amount: `${formatCurrencyDetail(maxClaimAmount)} ${currency}` })}`}
              </div>
            </div>
          )
        }
      </div>
      {ableClaim && (
        <Button
          variant="success"
          size='sm'
          className="w-[90px] ml-[10px]"
          onClick={handleClaim}
          disabled={loading}
          loading={loading}
        >{t_reward('claim')}</Button>
      )}
    </div>
  );
};
